import React, { useRef, useState } from "react";

export function TriproutesEditorPublication({ api, agent, site, dirty, canEdit, onPublished }) {
  const kind = { solution_triproutes_route_refinement_file: "route_refinement_file", solution_triproutes_route_improvement: "route_improvement" }[agent.id];
  const [state, setState] = useState({ busy: false, report: null, message: "", error: "" });
  const intent = useRef(null);
  if (!kind) return null;
  const check = async () => {
    setState({ busy: true, report: null, message: "", error: "" });
    try {
      const report = await api.request(`/v1/triproutes/editors/validation/${kind}?site=${site}`);
      intent.current = { digest: report.contractDigest, key: crypto.randomUUID() };
      setState({ busy: false, report, message: "", error: "" });
    } catch (error) { setState({ busy: false, report: null, message: "", error: error.message || "Не удалось проверить готовность." }); }
  };
  const publish = async () => {
    if (!state.report?.ready || !intent.current) return;
    setState((s) => ({ ...s, busy: true, error: "" }));
    try {
      await api.request(`/v1/triproutes/editors/publish/${kind}?site=${site}`, { method: "POST", headers: { "Idempotency-Key": intent.current.key }, body: { contractDigest: intent.current.digest } });
      setState({ busy: false, report: null, message: "Версия опубликована. Исполнитель для новых заданий выбирается в настройках подключения TripRoutes.", error: "" });
      await onPublished();
    } catch (error) { setState((s) => ({ ...s, busy: false, error: error.message || "Не удалось опубликовать версию." })); }
  };
  return <div className="agent-setting-actions">
    <button className="button ghost small" disabled={state.busy || dirty || !agent.revision} onClick={check}>Проверить готовность</button>
    {dirty && <small>Сначала сохраните выбранную модель.</small>}
    {state.report && !dirty && <div>
      {state.report.ready ? <p>Готов к публикации: {state.report.binding.provider}:{state.report.binding.model} · предел ответа {state.report.binding.maxOutputTokens} токенов.</p> : <ul>{state.report.blockers.map((b) => <li key={`${b.code}:${b.field}`}>{b.message}</li>)}</ul>}
      {state.report.ready && canEdit && <button className="button primary small" disabled={state.busy} onClick={publish}>Подтвердить публикацию для {site.toUpperCase()}</button>}
    </div>}
    {state.message && <p className="success-note" role="status">{state.message}</p>}
    {state.error && <p className="inline-problem" role="alert">{state.error}</p>}
  </div>;
}
